import TaskNumber from 'contents/ProtocolEditor/Components/TaskNumber';
import TaskTitle from 'contents/ProtocolEditor/TaskList/Task/Components/TaskTitle';
import TaskWrapper from 'contents/ProtocolEditor/TaskList/Task/Components/TaskWrapper';
import PropTypes from 'prop-types';
import TaskAction from 'contents/ProtocolEditor/TaskList/Task/Components/TaskAction';
import withIntl from 'lib/withIntl';
import {ExecutionStatus} from 'constants/dataEnum';
import Spinner from 'components/Spinner/Spinner';
import TaskExecutedTick from 'components/TaskExecutedTick';
import TaskPipettingProfileWrapper from 'contents/ProtocolEditor/TaskList/Task/Components/TaskPipettingProfileWrapper';
import PipettingProfileItems from 'contents/ProtocolEditor/TaskList/PipettingProfile/PipettingProfileItem/PipettingProfileItems';
import PoolingTaskDescription from './TaskDescription/PoolingTaskDescription';

function PoolingAspirateVolume({
  disableDrag,
  disallowEdit,
  executionStatus,
  isHighlighted,
  intl,
  labware,
  labwareState,
  number,
  readOnly,
  reuseTips,
  runtimeMode,
  showEditButton,
  tasks,
  onEdit,
  onReuseTipsChange,
  onShowMenuContext,
}) {
  return (
    <TaskWrapper disableDrag={disableDrag} isSelected={isHighlighted} onContextMenu={onShowMenuContext}>
      <TaskNumber number={number} isHighlighted={isHighlighted} />
      <TaskTitle
        title="Pooling: Source aspirate volume"
        description={
          <PoolingTaskDescription number={number} labware={labware} tasks={tasks} labwareState={labwareState} />
        }
      />
      {!runtimeMode && !readOnly && showEditButton && <TaskAction onEdit={onEdit} />}
      {!runtimeMode && disallowEdit && !readOnly && (
        <TaskPipettingProfileWrapper>
          <PipettingProfileItems.ReuseTips
            reuseTips={reuseTips}
            onReuseTipsChange={onReuseTipsChange}
            toolTipTitle={intl.formatMessage({id: 'protocolEditor.pooling.reuseTip.info'})}
          />
        </TaskPipettingProfileWrapper>
      )}
      {runtimeMode && executionStatus === ExecutionStatus.EXECUTING && <Spinner />}
      {runtimeMode && executionStatus === ExecutionStatus.EXECUTED && <TaskExecutedTick />}
    </TaskWrapper>
  );
}

PoolingAspirateVolume.propTypes = {
  disableDrag: PropTypes.bool,
  disallowEdit: PropTypes.bool,
  executionStatus: PropTypes.string.isRequired,
  isHighlighted: PropTypes.bool.isRequired,
  intl: PropTypes.any.isRequired,
  labware: PropTypes.object.isRequired,
  labwareState: PropTypes.object,
  number: PropTypes.number.isRequired,
  readOnly: PropTypes.bool,
  reuseTips: PropTypes.bool,
  runtimeMode: PropTypes.bool,
  showEditButton: PropTypes.bool,
  tasks: PropTypes.array.isRequired,
  onEdit: PropTypes.func,
  onReuseTipsChange: PropTypes.func,
  onShowMenuContext: PropTypes.func,
};

PoolingAspirateVolume.defaultProps = {
  disableDrag: false,
  disallowEdit: false,
  labwareState: {},
  readOnly: false,
  reuseTips: false,
  runtimeMode: false,
  showEditButton: false,
  onEdit: () => {},
  onReuseTipsChange: () => {},
  onShowMenuContext: () => {},
};

export default withIntl(PoolingAspirateVolume);
